import { render, staticRenderFns } from "./regularTrading.vue?vue&type=template&id=f9223d9e&scoped=true&"
import script from "./regularTrading.vue?vue&type=script&lang=js&"
export * from "./regularTrading.vue?vue&type=script&lang=js&"
import style0 from "./regularTrading.vue?vue&type=style&index=0&id=f9223d9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9223d9e",
  null
  
)

export default component.exports